//# sourceMappingURL=prompts.mjs.map
/// <reference types="./prompts.d.mts" />
import * as $ai_config from "../../../../data_types/data/ai_config.mjs";
import * as $remote from "../../../../data_types/data/remote.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $input from "../../../../ds/ds/components/input.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $text from "../../../../ds/ds/typography/text.mjs";
import * as $redraw from "../../../../redraw/redraw.mjs";
import * as $compose from "../../../../redraw_batteries/redraw/batteries/compose.mjs";
import * as $a from "../../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../../../sketch/sketch/css.mjs";
import * as $function from "../../../../tiamat/tiamat/function.mjs";
import * as $msg from "../../../data/msg.mjs";
import * as $store from "../../../data/store.mjs";
import { toList, CustomType as $CustomType } from "../../../gleam.mjs";
import * as $common from "../../../view/common.mjs";

export class PromptFieldProps extends $CustomType {
  constructor(label, placeholder, value, set_value, disabled, on_submit) {
    super();
    this.label = label;
    this.placeholder = placeholder;
    this.value = value;
    this.set_value = set_value;
    this.disabled = disabled;
    this.on_submit = on_submit;
  }
}
export const PromptFieldProps$PromptFieldProps = (label, placeholder, value, set_value, disabled, on_submit) =>
  new PromptFieldProps(label, placeholder, value, set_value, disabled, on_submit);
export const PromptFieldProps$isPromptFieldProps = (value) =>
  value instanceof PromptFieldProps;
export const PromptFieldProps$PromptFieldProps$label = (value) => value.label;
export const PromptFieldProps$PromptFieldProps$0 = (value) => value.label;
export const PromptFieldProps$PromptFieldProps$placeholder = (value) =>
  value.placeholder;
export const PromptFieldProps$PromptFieldProps$1 = (value) => value.placeholder;
export const PromptFieldProps$PromptFieldProps$value = (value) => value.value;
export const PromptFieldProps$PromptFieldProps$2 = (value) => value.value;
export const PromptFieldProps$PromptFieldProps$set_value = (value) =>
  value.set_value;
export const PromptFieldProps$PromptFieldProps$3 = (value) => value.set_value;
export const PromptFieldProps$PromptFieldProps$disabled = (value) =>
  value.disabled;
export const PromptFieldProps$PromptFieldProps$4 = (value) => value.disabled;
export const PromptFieldProps$PromptFieldProps$on_submit = (value) =>
  value.on_submit;
export const PromptFieldProps$PromptFieldProps$5 = (value) => value.on_submit;

function disabled_submit_website_prompts(ai_config, labels, ignore, breadcrumbs) {
  return $a.disabled(
    (() => {
      if (ai_config instanceof $remote.NotLoaded) {
        return false;
      } else if (ai_config instanceof $remote.Loading) {
        return false;
      } else if (ai_config instanceof $remote.Errored) {
        return false;
      } else {
        let a = ai_config[0];
        let c = a.config.website_prompt_config;
        return ((labels === c.labels_instructions) && (ignore === c.what_to_ignore)) && (breadcrumbs === c.breadcrumbs_instructions);
      }
    })(),
  );
}

function prompt_field(props) {
  return $l.column(
    toList([$l.gap(4)]),
    toList([]),
    toList([
      $l.row(
        toList([$l.styles(toList([$css.compose($text.sm($text.medium))]))]),
        toList([]),
        toList([$h.text(props.label)]),
      ),
      $l.column(
        toList([$l.gap(4)]),
        toList([]),
        toList([
          $input.input(
            (() => {
              let _pipe = $input.value(props.value);
              let _pipe$1 = $input.multiline(_pipe, true);
              let _pipe$2 = $input.placeholder(_pipe$1, props.placeholder);
              let _pipe$3 = $input.disabled(_pipe$2, props.disabled);
              let _pipe$4 = $input.on_input(_pipe$3, props.set_value);
              return $input.on_submit(_pipe$4, props.on_submit);
            })(),
          ),
        ]),
      ),
    ]),
  );
}

function submit_website_prompt_config(
  ai_config,
  labels,
  ignore,
  breadcrumbs,
  dispatch
) {
  if (ai_config instanceof $remote.NotLoaded) {
    return undefined;
  } else if (ai_config instanceof $remote.Loading) {
    return undefined;
  } else if (ai_config instanceof $remote.Errored) {
    return undefined;
  } else {
    dispatch(
      new $msg.UserSubmittedWebsitePromptConfig(
        new $ai_config.WebsitePromptConfig(labels, ignore, breadcrumbs),
      ),
    );
    return undefined;
  }
}

function use_prompt_field(ai_config, get) {
  return $function.tap(
    $redraw.use_state(""),
    (_use0) => {
      let set = _use0[1];
      return ((_capture) => { return $redraw.use_effect(_capture, [ai_config]); })(
        () => {
          let $ = $remote.map(
            ai_config,
            (a) => { return a.config.website_prompt_config; },
          );
          if ($ instanceof $remote.Loaded) {
            let prompt_config = $[0];
            return set(get(prompt_config));
          } else {
            return undefined;
          }
        },
      );
    },
  );
}

function website_scrapping() {
  return $redraw.component_(
    "WebsiteScrapping(View)",
    (_) => {
      let store = $store.use_state();
      let dispatch = $store.use_dispatch();
      let dispatch$1 = (m) => { return dispatch(new $msg.AiConfig(m)); };
      let ai_config = $store.organization_ai_config(store);
      let disabled = !$remote.is_loaded(ai_config);
      let $ = use_prompt_field(
        ai_config,
        (c) => { return c.labels_instructions; },
      );
      let labels = $[0];
      let set_labels = $[1];
      let $1 = use_prompt_field(ai_config, (c) => { return c.what_to_ignore; });
      let ignore = $1[0];
      let set_ignore = $1[1];
      let $2 = use_prompt_field(
        ai_config,
        (c) => { return c.breadcrumbs_instructions; },
      );
      let breadcrumbs = $2[0];
      let set_breadcrumbs = $2[1];
      let on_submit = () => {
        return submit_website_prompt_config(
          ai_config,
          labels,
          ignore,
          breadcrumbs,
          dispatch$1,
        );
      };
      return $l.column(
        toList([$l.gap(12)]),
        toList([]),
        toList([
          $l.column(
            toList([$l.gap(6)]),
            toList([]),
            toList([
              $common.underlined_title(
                toList([]),
                toList([$h.text("Website scrapping prompts")]),
              ),
              $l.row(
                toList([
                  $l.styles(toList([$css.compose($text.sm($text.regular))])),
                ]),
                toList([]),
                toList([
                  $h.text(
                    "Customise the prompts used when scrapping website content. ",
                  ),
                  $h.text(
                    "Changes are not saved until you press the save button.",
                  ),
                ]),
              ),
            ]),
          ),
          $l.column(
            toList([$l.gap(8)]),
            toList([]),
            toList([
              prompt_field(
                new PromptFieldProps(
                  "Labels instructions",
                  "Tags are usually related to a product name or service name…",
                  labels,
                  set_labels,
                  disabled,
                  on_submit,
                ),
              ),
              prompt_field(
                new PromptFieldProps(
                  "What to ignore",
                  "Header menus, footer, sidebar widgets, login buttons…",
                  ignore,
                  set_ignore,
                  disabled,
                  on_submit,
                ),
              ),
              prompt_field(
                new PromptFieldProps(
                  "Breadcrumbs instructions",
                  "Extract page hierarchy from JSON-LD, Open Graph, breadcrumb nav, or URL path…",
                  breadcrumbs,
                  set_breadcrumbs,
                  disabled,
                  on_submit,
                ),
              ),
            ]),
          ),
          $l.row(
            toList([$l.justify("end"), $l.gap(6)]),
            toList([]),
            toList([
              $button.primary(
                toList([
                  disabled_submit_website_prompts(
                    ai_config,
                    labels,
                    ignore,
                    breadcrumbs,
                  ),
                  $e.on_click((_) => { return on_submit(); }),
                ]),
                toList([$h.text("Save changes")]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

export function view() {
  return $compose.static$(
    website_scrapping(),
    (website_scrapping) => {
      return $redraw.component_(
        "Prompts(View)",
        (_) => {
          return $l.column(
            toList([$l.gap(24)]),
            toList([]),
            toList([website_scrapping()]),
          );
        },
      );
    },
  );
}
